/* eslint-disable no-restricted-imports */
import {createRoot, Root} from 'react-dom/client'
import {createElement} from 'react'
import UIGame, {UIGameProps} from './core/UIGame'
import {flushSync} from 'react-dom'

export {resizeUIGame} from './core/UIGame'
export {createFeedMessageDataForGameChatData} from './core/UIGameFeeds/UIGameFeedMessage/FeedMessageDataChats'
export {setGlobalGameEndProviderProps, setGlobalGameEndNumberOfPlayersJoinedRematch} from './core/UIGameEnd'
export {addGlobalSpectatorMessage} from './core/UIGameFeeds/UIGameChat/UIGameChat'
export {addNewLog} from './core/UIGameFeeds/UIGameLog/UIGameLog'
export {CARD_TOOLTIP_LINK_PREFIX} from './core/UIGameFeeds/UIGameFeedMessage/FeedMessageDataLogs'
export {setGlobalCanResign} from './core/UIGameHelpButtons/UIGameHelpLeaveGameContext'
export {getCostInformation} from './core/UIGameHelpButtons/UIGameHelpInformationButton/UIGameHelpCostsInformation/UIGameCostsInformation'
export {setGlobalSpectators} from './core/UIGameSpectators/UIGameSpectatorsContext'
export {CARD_IMAGES, CARD_TIP_TITLE, CARD_TIP_BODY, CARD_POPUP_BODY, CARD_RATIO, getIfCardHasBadgeFromType, cardEnumsToCardState} from './utils/cards.ts'
export {VICTORY_POINT_END_GAME_TIP, VICTORY_POINT_IMAGES} from './utils/vp.ts'
export {CurrentStateMessageUtils, type CurrentStateMessageInput} from './core/UIGameCurrentStatus/CurrentStateMessageUtils'
export {getGlobalPositionOfPlayerCard} from './core/UIGamePlayerInformation'
export {getPointPositionFromBank} from './core/UIGameBank/UIGameBank'
export {getPointPositionFromPlayerInventory, getCardDimensionsFromPlayerInventory} from './core/UIGamePlayerCardInventory/UIGamePlayerCardInventory'
export {UIGameAchievementEventEmitter, type UIGameAddAchievementEvent} from './core/UIGameAchievement/UIGameAchievementContainer'
export {createGameStore, type GameStore} from './store/gameStore'
export type {GameUserSettingsProps} from './store/slices/gameUserSettingsSlice.ts'
export type {UIGameActionBoxBaseProps} from './common/UIGameActionBox/UIGameActionBoxBase'
export type {UIGameActionBoxPickCardProps} from './common/UIGameActionBox/variants/UIGameActionBoxPickCard/UIGameActionBoxPickCard'
export type {UIGameActionBoxPickPlayerProps} from './common/UIGameActionBox/variants/UIGameActionBoxPickPlayer/UIGameActionBoxPickPlayer'
export type {UIGameActionBoxPickDiceProps} from './common/UIGameActionBox/variants/UIGameActionBoxPickDice/UIGameActionBoxPickDice'
export {GAME_ACTION_TO_BEGINNER_HINT_TYPE} from './core/UIGameBeginnerHint/utils'
export type {ReplayHighlightData, ReplayHighlightType} from './core/UIGameReplayControls/ReplayControlsContent/ReplaySlider'
export type {PlayerInformationContainerPosition, PlayerInformationContainerSize} from './store/slices/gamePortraitPlayerInformationLayoutSlice'

let reactRoot: Root | null = null

export const renderUIGame = (props: UIGameProps) => {
    const {gameManager} = props
    let container = document.getElementById('ui-game') as HTMLDivElement | null
    if(container && reactRoot) {
        reactRoot.unmount()
        reactRoot = null
    }
    if(!container) {
        container = document.createElement('div')
        container.id = 'ui-game'
        container.style.pointerEvents = 'none'
        container.style.position = 'absolute'
        container.style.left = gameManager.canvasController.app.view.style.left
        container.style.width = gameManager.canvasController.appW + 'px'
        container.style.height = gameManager.canvasController.appH + 'px'
        document.body.appendChild(container)
    }

    reactRoot = createRoot(container)
    // TODO remove flushSync when everything migrated to React
    flushSync(() => {
        reactRoot?.render(createElement(UIGame, props))
    })
}
